import React from 'react'
import { StyledModal, ModalHeader, ModalContent, ModalButton, StyledModalContainer, SadFaceIcon } from "./styles"


export const ModalBloqueioPlano = ({
    onClose = () => {},
    children,
    title,
    buttonText,
  }) => {
    return (
      <StyledModal>
         <SadFaceIcon />
        <StyledModalContainer>
          <ModalHeader>{title}</ModalHeader>
          <br />
          <ModalContent>{children}</ModalContent>
          <br />
          <ModalButton onClick={onClose}>{buttonText}</ModalButton>
        </StyledModalContainer>
      </StyledModal>
    );
  };

export default ModalBloqueioPlano;

